import { brand } from './brand';
import { theme } from './theme';
/**
 * Default focus visible styling to be used in both tailwind and linaria setups
 */
export const defaultFocusStyles = {
    /* Default focus styles */
    '&:focus': {
        outline: '0',
        boxShadow: `0 0 0 ${theme.border.width.xs} ${brand.shared.color.focus.outline.inner}`,
    },
    /* Reset default focus styles when focus-visible is supported */
    '&:focus:not(:focus-visible)': {
        boxShadow: 'none',
    },
    /* Focus-visible styles */
    '&:focus-visible': {
        outline: '0',
        boxShadow: `0 0 0 ${theme.border.width.xs} ${brand.shared.color.focus.outline.outer}`,
    },
};
